import {reactive} from "vue";
import {PenaleData} from "@/app/data/PenaleData";
import {PenaleDashboardFlow} from "@/app/data/PenaleDashboardFlow";
import {User} from "@/app/data/User";
import {PenalePercorsoFlow} from "@/app/data/PenalePercorsoFlow";
import type {KeyValoreStr} from "@/app/data/DataTypes";
import { TestoData } from "./data/TestoData";
import { TestoResult } from "./data/TestoResult";
import {PenaleAdmin} from "@/app/data/PenaleAdmin";
import {FamigliaAdmin} from "@/app/data/FamigliaAdmin";
import {FamigliaData} from "@/app/data/FamigliaData";
import {FamigliaDashboardFlow} from "@/app/data/FamigliaDashboardFlow";
import {FamigliaPercorsoFlow} from "@/app/data/FamigliaPercorsoFlow";
import {ResponsabilitaAdmin} from "@/app/data/ResponsabilitaAdmin";
import {ResponsabilitaData} from "@/app/data/ResponsabilitaData";
import {ResponsabilitaDashboardFlow} from "@/app/data/ResponsabilitaDashboardFlow";
import {ResponsabilitaPercorsoFlow} from "@/app/data/ResponsabilitaPercorsoFlow";

declare let user: User;
declare let returnedToken: any;

export class Model {

    protected static instance: Model;
    protected static reactiveInstance: Model;

    //sys
    public user: User = new User();
    public abbonatoDejure: boolean = false;
    public abbonatoPenale: boolean = false;
    public abbonatoFamiglia: boolean = false;
    public abbonatoResponsabilita: boolean = false;
    public returnedToken: string = "";
    public sidebarCollapsed: boolean = false;

    //data pen
    static pen_setupped: boolean = false;
    public pen_get_dashboard: PenaleData = new PenaleData();
    public pen_get_percorso: PenaleData = new PenaleData();
    public pen_flow_dashboard: PenaleDashboardFlow = new PenaleDashboardFlow();
    public pen_flow_percorso: PenalePercorsoFlow = new PenalePercorsoFlow();

    //data fam
    static fam_setupped: boolean = false;
    public fam_get_dashboard: FamigliaData = new FamigliaData();
    public fam_get_percorso: FamigliaData = new FamigliaData();
    public fam_flow_dashboard: FamigliaDashboardFlow = new FamigliaDashboardFlow();
    public fam_flow_percorso: FamigliaPercorsoFlow = new FamigliaPercorsoFlow();

    //data res
    static res_setupped: boolean = false;
    public res_get_dashboard: ResponsabilitaData = new ResponsabilitaData();
    public res_get_percorso: ResponsabilitaData = new ResponsabilitaData();
    public res_flow_dashboard: ResponsabilitaDashboardFlow = new ResponsabilitaDashboardFlow();
    public res_flow_percorso: ResponsabilitaPercorsoFlow = new ResponsabilitaPercorsoFlow();

    //vars pen
    public pen_lista_giudici: KeyValoreStr[] = []; //{ "giudice": "zzz" }
    public pen_lista_citta: KeyValoreStr[] = []; //{ "citta": "zzz", "id_localita": "234234" }
    public lista_capo_imputazione_legge: KeyValoreStr[] = []; //{ "rubrica": null, "capo_imputazione_legge": "10-bis d.lgs. n. 74/2000", tot: 0 }
    public lista_capo_imputazione_legge_rubrica: KeyValoreStr[] = []; //{ "rubrica": null, "capo_imputazione_legge": "10-bis d.lgs. n. 74/2000", tot: 0 }
    static lista_esito_del_processo: string[] = ["Mista", "Non assolti", "Tutti assolti"];
    static lista_esito_del_processo_labels: string[] = ["Sentenze miste" , "Sentenze di condanna", "Sentenze di assoluzione"];
    public temp_capo_imputazione_legge: string = "";
    public temp_oggetto_di_giudizio: string = "";

    //vars fam
    public fam_lista_giudici: KeyValoreStr[] = [];
    public fam_lista_citta: KeyValoreStr[] = [];
    static lista_oggetto_di_giudizio: string[] = ["Divorzio", "Separazione"];
    static lista_tipologia_procedimento: string[] = ["Consensuale" , "Giudiziale"];
    static lista_tipologia_procedimento_percorso: string[] = ["Consensuale" , "Giudiziale", "Entrambe"];
    static lista_addebito: string[] = ["Si" , "No"];
    static lista_regime_affidamento: string[] = ["Affidamento ai servizi sociali" , "Affidamento condiviso", "Affidamento esclusivo", "Affidamento superesclusivo"];
    static lista_regime_mantenimento: string[] = ["Mantenimento diretto" , "Mantenimento indiretto"];
    static lista_regime_collocamento: string[] = ["Collocamento alternato" , "Collocamento esclusivo", "Collocamento invariato", "Collocamento prevalente"];
    static lista_motivi_addebito_separazione: string[] = ["Obbligo di assistenza materiale" , "Obbligo di assistenza morale", "Obbligo di coabitazione", "Obbligo di collaborazione nell'interesse della famiglia", "Obbligo di fedeltà"];
    static lista_assegnazione_casa_familiare: string[] = ["Marito" , "Moglie", "Ente"];
    static lista_valori_assegno_minMax: number[] = [0, 1000000, 50];
    static lista_oggetto_giudizio_citta_labels: string[] = ["Divorzio", "Separazione"];

    //vars res
    public res_lista_giudici: KeyValoreStr[] = [];
    public res_lista_citta: KeyValoreStr[] = [];
    static lista_tipologia_danno: string[] = ["Patrimoniale", "Non patrimoniale", "Entrambi"];
    static lista_tipologia_danno_per_citta: string[] = ["Patrimoniale", "Non patrimoniale", "Entrambi"];
    static lista_tipologia_danno_patrimoniale: string[] = ["Danno emergente", "Lucro cessante", "Entrambi"];
    static lista_tipologia_danno_non_patrimoniale: string[] = ["Biologico", "Morale", "Esistenziale", "Vita di relazione", "Tutti"];
    static lista_domanda_accolta: string[] = ["Si", "No"];
    static lista_risarcimento: string[] = ["Accolto parzialmente", "Accolto totalmente", "Rigettato"];
    static lista_risarcimento_richiesto_minMax: number[] = [0, 1000000, 50];
    static lista_risarcimento_disposto_totale_minMax: number[] = [0, 1000000, 50];
    static lista_risarcimento_minMax: number[] = [0, 1000000, 50];
    public temp_tipologia_danno: string = "";

    //common
    static pagination_size: number = 20;
    static lista_importi_minMax: number[] = [0, 1000000, 1000]; //min, max, step
    static lista_anno_minMax: number[] = [2001, new Date().getFullYear(), 1]; //min, max, step
    public generatingPdf: boolean = false;
    public openingDejure: boolean = false;
    public testo_data: TestoData = new TestoData();
    public testo_result: TestoResult = new TestoResult();

    //admin
    public isAdmin: boolean = false;
    public adminPage: AdminPages = AdminPages.Home;
    public pen_admin: PenaleAdmin = new PenaleAdmin();
    public fam_admin: FamigliaAdmin = new FamigliaAdmin();
    public res_admin: ResponsabilitaAdmin = new ResponsabilitaAdmin();

    protected constructor() {
        //keep it protected to help with the singleton instance
    }

    public static getInstance(): Model {
        if (!Model.instance) {
            Model.initModel();
        }
        return Model.instance;
    }

    public static getReactiveInstance(): Model {
        if (!Model.instance) {
            Model.initModel();
        }
        return Model.reactiveInstance;
    }

    protected static initModel(): void {
        Model.instance = new Model();
        Model.reactiveInstance = reactive(Model.instance);
    }

    public penResetData(): void {
        this.pen_get_dashboard = new PenaleData();
        this.pen_get_percorso = new PenaleData();
        this.pen_flow_dashboard = new PenaleDashboardFlow();
        this.pen_flow_percorso = new PenalePercorsoFlow();
    }
    public resetAdmin(): void {
        this.pen_admin = new PenaleAdmin();
        this.fam_admin = new FamigliaAdmin();
        this.res_admin = new ResponsabilitaAdmin();
    }
    public famResetData(): void {
        this.fam_get_dashboard = new FamigliaData();
        this.fam_get_percorso = new FamigliaData();
        this.fam_flow_dashboard = new FamigliaDashboardFlow();
        this.fam_flow_percorso = new FamigliaPercorsoFlow();
    }
    public resResetData(): void {
        this.res_get_dashboard = new ResponsabilitaData();
        this.res_get_percorso = new ResponsabilitaData();
        this.res_flow_dashboard = new ResponsabilitaDashboardFlow();
        this.res_flow_percorso = new ResponsabilitaPercorsoFlow();
    }

    public penCopyPercorsoToDashBoard(): void {
        this.pen_flow_dashboard.capo_imputazione_legge = this.pen_flow_percorso.capo_imputazione_legge;
        this.pen_flow_dashboard.importo_evaso_min = this.pen_flow_percorso.importo_evaso_min;
        this.pen_flow_dashboard.importo_evaso_max = this.pen_flow_percorso.importo_evaso_max;
        this.pen_flow_dashboard.importo_evaso_active = this.pen_flow_percorso.importo_evaso_active;
        this.pen_flow_dashboard.importo_evaso_da = this.pen_flow_percorso.importo_evaso_da;
        this.pen_flow_dashboard.importo_evaso_a = this.pen_flow_percorso.importo_evaso_a;
        this.pen_flow_dashboard.assoluzione = this.pen_flow_percorso.assoluzione;
        this.pen_flow_dashboard.assoluzione_motivo = this.pen_flow_percorso.assoluzione_motivo;
        this.pen_flow_dashboard.pena_principale = this.pen_flow_percorso.pena_principale;

        //per analisiview
        if (this.temp_capo_imputazione_legge != "") {
            this.pen_flow_dashboard.capo_imputazione_legge = this.temp_capo_imputazione_legge;
            this.temp_capo_imputazione_legge = "";
        }
    }
    public famCopyPercorsoToDashBoard(): void {
        this.fam_flow_dashboard = new FamigliaDashboardFlow();
        
        this.fam_flow_dashboard.oggetto_di_giudizio = this.fam_flow_percorso.oggetto_di_giudizio;
        this.fam_flow_dashboard.tipologia_procedimento = this.fam_flow_percorso.tipologia_procedimento;
        this.fam_flow_dashboard.addebito = this.fam_flow_percorso.addebito;
        this.fam_flow_dashboard.motivi_addebito_separazione = this.fam_flow_percorso.motivi_addebito_separazione;
        this.fam_flow_dashboard.regime_affidamento = this.fam_flow_percorso.regime_affidamento;
        this.fam_flow_dashboard.regime_collocamento = this.fam_flow_percorso.regime_collocamento;
        this.fam_flow_dashboard.regime_mantenimento = this.fam_flow_percorso.regime_mantenimento;

        //per analisiview
        if (this.temp_oggetto_di_giudizio != "") {
            this.fam_flow_dashboard.oggetto_di_giudizio = this.temp_oggetto_di_giudizio;
            this.temp_oggetto_di_giudizio = "";
        }
    }
    public resCopyPercorsoToDashBoard(): void {
        this.res_flow_dashboard = new ResponsabilitaDashboardFlow();

        this.res_flow_dashboard.tipologia_danno = this.res_flow_percorso.tipologia_danno;
        this.res_flow_dashboard.tipologia_danno_patrimoniale = this.res_flow_percorso.tipologia_danno_patrimoniale;
        this.res_flow_dashboard.tipologia_danno_non_patrimoniale = this.res_flow_percorso.tipologia_danno_non_patrimoniale;
        this.res_flow_dashboard.domanda_accolta = this.res_flow_percorso.domanda_accolta; 
        this.res_flow_dashboard.risarcimento = this.res_flow_percorso.risarcimento;
        this.res_flow_dashboard.risarcimento_richiesto_active = this.res_flow_percorso.risarcimento_richiesto_active;
        this.res_flow_dashboard.risarcimento_richiesto_min = this.res_flow_percorso.risarcimento_richiesto_min;
        this.res_flow_dashboard.risarcimento_richiesto_max = this.res_flow_percorso.risarcimento_richiesto_max;
        this.res_flow_dashboard.risarcimento_richiesto_da = this.res_flow_percorso.risarcimento_richiesto_da;
        this.res_flow_dashboard.risarcimento_richiesto_a = this.res_flow_percorso.risarcimento_richiesto_a;
        this.res_flow_dashboard.risarcimento_disposto_totale_active = this.res_flow_percorso.risarcimento_disposto_totale_active;
        this.res_flow_dashboard.risarcimento_disposto_totale_min = this.res_flow_percorso.risarcimento_disposto_totale_min;
        this.res_flow_dashboard.risarcimento_disposto_totale_max = this.res_flow_percorso.risarcimento_disposto_totale_max;
        this.res_flow_dashboard.risarcimento_disposto_totale_da = this.res_flow_percorso.risarcimento_disposto_totale_da;
        this.res_flow_dashboard.risarcimento_disposto_totale_a = this.res_flow_percorso.risarcimento_disposto_totale_a;

        //per analisiview
        if (this.temp_tipologia_danno != "") {
            this.res_flow_dashboard.tipologia_danno = this.temp_tipologia_danno;
            this.temp_tipologia_danno = "";
        }
    }
}

export enum AdminPages {
    Home = 0,
    Penale_Penale = 1,
    Penale_ReatoRubrica = 2,
    Famiglia_Famiglia = 3,
    Penale_Procedure = 4,
    Responsabilita_Responsabilita = 5
}